<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo" >
      <el-menu-item index="1" @click="toNewRouter('yq-information')" v-if="permissionCodes.indexOf('001001000') !== -1">
        <i class="el-icon-damai-ic_yuanquxinxi"></i>
        <span slot="title">公寓信息</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('yq-notice-management')" v-if="permissionCodes.indexOf('001002000') !== -1">
        <i class="el-icon-damai-ic_yuanqugonggao"></i>
        <span slot="title">公寓公告</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('housing-management')" v-if="permissionCodes.indexOf('001003000') !== -1">
        <i class="el-icon-damai-ic_fangwuguanli"></i>
        <span slot="title">房屋管理</span>
      </el-menu-item>
      <el-submenu index="4" v-if="permissionCodes.indexOf('001004000') !== -1 || permissionCodes.indexOf('001004005') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_zujinguanli"></i>
          <span>承租管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="4-1" @click="toNewRouter('lessee-management')" v-if="permissionCodes.indexOf('001004000') !== -1">个人承租</el-menu-item>
          <el-menu-item index="4-2" @click="toNewRouter('business-management')" v-if="permissionCodes.indexOf('001004005') !== -1">单位承租</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="5" @click="toNewRouter('person-management')" v-if="permissionCodes.indexOf('001005000') !== -1">
        <i class="el-icon-damai-renyuan"></i>
        <span slot="title">人员管理</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('account-management')" v-if="permissionCodes.indexOf('001007000') !== -1">
        <i class="el-icon-damai-ic_zizhanghaoguanli"></i>
        <span slot="title">子账号管理</span>
      </el-menu-item>
      <el-menu-item index="7" @click="toNewRouter('role-management')" v-if="permissionCodes.indexOf('001008000') !== -1">
        <i class="el-icon-damai-ic_jiaoseguanli"></i>
        <span slot="title">角色管理</span>
      </el-menu-item>
      <el-submenu index="8" v-if="permissionCodes.indexOf('001011000') !== -1 || permissionCodes.indexOf('001012000') !== -1 || permissionCodes.indexOf('001013000') !== -1 || permissionCodes.indexOf('001014003') !== -1 || permissionCodes.indexOf('001017000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_peizhiguanli"></i>
          <span>配置管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="8-1" @click="toNewRouter('banner-manage')" v-if="permissionCodes.indexOf('001011000') !== -1">Banner配置</el-menu-item>
          <el-menu-item index="8-2" @click="toNewRouter('navigation-bar-config')" v-if="permissionCodes.indexOf('001012000') !== -1">导航栏配置</el-menu-item>
          <el-menu-item index="8-3" @click="toNewRouter('resource-approval-manage')" v-if="permissionCodes.indexOf('001013000') !== -1">审批配置</el-menu-item>
<!--          <el-menu-item index="8-4" @click="toNewRouter('boss-bulletin-board')" v-if="permissionCodes.indexOf('001014003') !== -1">BOSS看板配置</el-menu-item>-->
          <el-menu-item index="8-5" @click="toNewRouter('face-authorization-config')" v-if="permissionCodes.indexOf('001017000') !== -1">人脸授权配置</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="9" @click="toNewRouter('resource-center-log')" v-if="permissionCodes.indexOf('001010000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: ["yq-information", "modify-yq-information"],
  2: ["yq-notice-management", "add-yq-notice", "modify-yq-notice"],
  3: ["housing-management", "housing-add", "housing-modify", "housing-building-add", "housing-building-modify",],
  '4-1': ["lessee-management", "lessee-add", "lessee-modify", "lessee-current"],
  '4-2': ["business-management", "business-add", "business-modify", "business-current",],
  5: ["person-management", "person-add", "person-modify", "person-current"],
  6: ["account-management", "account-add", "account-modify"],
  7: ["role-management", "role-add", "role-modify"],
  "8-1": ["banner-manage", "banner-add", "banner-modify"],
  "8-2": "navigation-bar-config",
  "8-3": ["resource-approval-manage", "resource-approval-modify"],
  "8-4": ["boss-bulletin-board", "boss-bulletin-board-add"],
  '8-5': ['face-authorization-config'],
  9: "resource-center-log",
});
export default {
  name: "resource-nav",
  mixins: [navMixin],
  data() {
    return {
      yqCode: "",
      isCollapse: bus.global.isCollapse,
      title1: "公寓信息",
      title2: "公寓宣传",
      indexOfRouterNameEntities,
      permissionCodes: "",
    };
  },
  created() {
    this.yqCode = bus.global.yqCode;
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  methods: {
    toNewRouter(name) {
      if (name === "housing-management") {
        window.sessionStorage.setItem(
          "housingManagementPageHousingTabState",
          ""
        );
        window.sessionStorage.setItem(
          "housingManagementPageBuildingTabState",
          ""
        );
      }
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/ResourceNav.vue